import React from "react";
import { Box, Typography } from "@mui/material";
import colorConfigs from "../../../configs/colorConfigs";
import { IBannerItems } from "../../../models/IBanner";
import { AWS_URL } from "../../../configs/constants";
import CustomButton from "../../common/Button/CustomButton";
import { typo } from "../../../assets/fonts/font";

interface VideoSectionProps {
  items: IBannerItems[];
}

const videoExtension = ["mp4", "ogg", "webm"];
const imageExtension = ["jpg", "jpeg"];

const VideoSection: React.FC<VideoSectionProps> = ({
  items,
}: VideoSectionProps) => {
  if (items.length === 0) return null;

  const { asset, text, btn_text, btn_url } = items[0];

  const checkAssestExtension = () => {
    const extension = asset.split(".").pop()?.toLowerCase();
    if (extension) {
      if (videoExtension.includes(extension)) return "video";
      if (imageExtension.includes(extension)) return "image";
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: colorConfigs.secondary,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: { xs: 3, md: 6 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {checkAssestExtension() === "image" && (
            <Box
              component="img"
              src={`${AWS_URL}/${asset}`}
              sx={{
                width: "100%",
                height: "auto",
              }}
            ></Box>
          )}
          {checkAssestExtension() === "video" && (
            <Box
              component="video"
              controls
              autoPlay
              muted
              playsInline
              loop          
              sx={{
                width: "100%",
                height: "auto",
              }}
            >
              <source src={`${AWS_URL}/${asset}`} type="video/mp4" />
              Your browser does not support the video tag.
            </Box>
          )}
        </Box>

        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: { xs: 2, md: 4 },
          }}
        >
          <Typography
            sx={{
              ...typo.sectionHeadline,
              padding: "5px 20px",
              margin: "10px",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              maxWidth: "100%",
            }}
          >
            {text}
          </Typography>
          <CustomButton buttonType="primary" href={btn_url}>
            <Typography component="span" sx={{ ...typo.button, color: colorConfigs.videoButtonText }}>
              {btn_text}
            </Typography>
          </CustomButton>
          {/* <Button
            sx={{
              color: colorConfigs.mainbody,
              background: colorConfigs.primary,
              borderRadius: "30px",
              padding: "10px 30px",
              margin: "10px",
              "&:hover": {
                backgroundColor: colorConfigs.secondary,
                color: colorConfigs.tertiary,
                border: `2px solid ${colorConfigs.primary}`,
                borderBottom: `3px solid ${colorConfigs.primary}`,
              },
            }}
            href={btn_url}
          ></Button> */}
        </Box>
      </Box>
    </Box>
  );
};

export default VideoSection;
